import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

import s from './ButtonsInRow.scss'


const ButtonsInRow = ({ className, children, alignLeft, alignRight, gutter, reversedOnDesktop }) => (
  <div className={className}>
    <div className={cx(s.twoButtonsInRow, { [s.alignLeft]: alignLeft, [s.alignRight]: alignRight, [s[gutter]]: Boolean(gutter), [s.reversedOnDesktop]: reversedOnDesktop })}>
      {children}
    </div>
  </div>
)

ButtonsInRow.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
  alignLeft: PropTypes.bool,
  alignRight: PropTypes.bool,
  gutter: PropTypes.oneOf([ 'xs', 'xsm', 'sm' ]),
  reversedOnDesktop: PropTypes.bool,
}

ButtonsInRow.defaultProps = {
  gutter: 'xs',
}


export default ButtonsInRow
